const userVerificationEvents = {

    signInFormOpened: 'sign_in_form_opened',
    sendVerifyRequest: 'send_verify_request_from_sign_in_form',
    sendVerifyRequestError: 'error_in_send_verify_request',
    signInSuccess: 'sign_in_verify_success'

};

export default userVerificationEvents;